import React, { FC } from 'react';
import { Empty, Spin } from 'antd';

import { NotFoundContent } from '../NotFoundContent';

import { AdvancedNotFoundContentProps, SamoletSelectProps } from 'ui/components/Select/types';

import { EmptyWrapper } from 'ui/components/Select/styled';

export type DefaultNotFoundContentProps = Pick<
  SamoletSelectProps,
  'loading' | 'onCreateNewOption' | 'createNewOptionText' | 'searchValue'
> &
  AdvancedNotFoundContentProps;

const DefaultNotFoundContent: FC<DefaultNotFoundContentProps> = ({
  loading,
  onCreateNewOption,
  createNewOptionText,
  searchValue,
  addButtonLabel,
  emptyDescription,
  additionalDescription,
  showCreateNewOptionText,
}) => {
  return loading ? (
    <Spin size='small' />
  ) : onCreateNewOption ? (
    <NotFoundContent
      createNewOptionText={createNewOptionText}
      search={searchValue}
      onClick={onCreateNewOption}
      addButtonLabel={addButtonLabel}
      emptyDescription={emptyDescription}
      additionalDescription={additionalDescription}
      showCreateNewOptionText={showCreateNewOptionText}
    />
  ) : (
    <EmptyWrapper>
      <Empty description={emptyDescription || 'Ничего не найдено'} />
    </EmptyWrapper>
  );
};

export default DefaultNotFoundContent;
